import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from '../../../shared/services/api/config.api';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable()
export class FundadminService {

  url;
  constructor(private httpClient: HttpClient) { }

  getForm(searchString,midDate,currentlanguage,flag) {
    if(flag==1){
      this.url = ApiConfig.baseURL + 'api/fundperformance/add';
    }
    if(flag==2){
      this.url = ApiConfig.baseURL + 'api/fundperformance/edit';
    }
    let params = new HttpParams()
      .set('searchString', searchString)
      .set('entryDate', midDate)
      .set('language', currentlanguage);

    return this.httpClient.get(this.url, {headers: ApiConfig.requestOptionsHeader, params: params});
  }

  addFunds(body:Object):Observable<any> {
    return this.httpClient.post(ApiConfig.baseURL + 'api/fundperformance/save', body, {headers: ApiConfig.requestOptionsHeaderForJson});
  }
}
